import React, { useState, useRef, useEffect } from 'react';

export default function ReadMore({ 
    text, 
    maxHeight = '4.8em', // 3 lines of text (1.6em line-height * 3)
    className = '',
    dir = 'ltr'
}) {
    const [showScroll, setShowScroll] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        if (textRef.current) {
            const element = textRef.current;
            const scrollHeight = element.scrollHeight;
            const clientHeight = element.clientHeight;
            
            // Show scroll indicator if content is taller than maxHeight
            setShowScroll(scrollHeight > clientHeight);
        }
    }, [text, maxHeight]);

    return (
        <div className={`read-more-container ${className}`}>
            <div
                ref={textRef}
                className="read-more-text"
                style={{
                    maxHeight: maxHeight,
                    overflow: showScroll ? 'auto' : 'hidden',
                    lineHeight: '1.6',
                    paddingRight: showScroll ? '8px' : '0',
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'var(--border-color) transparent'
                }}
                dir={dir}
            >
                {text}
            </div>
            {showScroll && (
                <div className="scroll-indicator">
                    <span style={{
                        fontSize: '0.8rem',
                        color: 'var(--LINK-COLOR)',
                        fontStyle: 'italic'
                    }}>
                        Scroll to read more
                    </span>
                </div>
            )}
        </div>
    );
} 